import React from "react";
import { motion } from "motion/react";
import { useResponsive } from "../utils/responsiveContext";

export const SkillsMarquee = ({ data }) => {
  const { isMobile } = useResponsive();
  const speed = isMobile ? 10 : 30;
  return (
    <div className="relative overflow-hidden w-full py-1">
      <motion.div
        className="flex gap-3 whitespace-nowrap"
        animate={{
          x: ["0%", "-100%"],
        }}
        transition={{
          repeat: Infinity,
          ease: "linear",
          duration: speed,
        }}
      >
        {data.map((item, index) => (
          <motion.div
            key={index}
            className="flex items-center justify-center rounded-full select-none"
          >
            <p
              className="flex items-center p-1 gap-2 rounded-full text-shade-4 bg-shade-3"
            >
              <span
                className={`${
                  isMobile ? "text-md" : "text-xl"
                } rounded-full bg-shade-4 shadow-custom-2 p-1`}
                style={{ color: item.color }}
              >
                {item.icon}
              </span>
              <span
                className={`${
                  isMobile ? "text-xs" : "text-sm"
                } text-white text-nowrap px-1`}
              >
                {item.name}
              </span>
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};
